import { z } from 'zod'
import { registryEntrySchema } from './database.js'

export const environmentGroupSchema = z.object({
  appName: z.string(),
  databases: z.array(registryEntrySchema),
})
export type EnvironmentGroup = z.infer<typeof environmentGroupSchema>

export const environmentsResponseSchema = z.object({
  apps: z.array(environmentGroupSchema),
  drift: z.object({
    orphans: z.array(z.string()),
    dangling: z.array(z.string()),
  }),
})
export type EnvironmentsResponse = z.infer<typeof environmentsResponseSchema>
